export default "__VITE_ASSET__CaK2$IFi__"